import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useNavigate, useParams } from "react-router-dom";
import { FormProvider } from "./context/formsContext";
import { Forms } from "./Forms";
import { useInitialValues } from "./hooks";

type Props = {};

export default function FormsIndex(props: Props) {
	const navigate = useNavigate();
	const { AssetIdParam } = useParams();
	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	if (!AssetIdParam) {
		navigate(`/forms/${defaultAreaId}`);
	}

	// useSearchParamsToReducer is now called inside Filters component
	return (
		<>
			<HelmetDexteel title="Forms" />
			<FormProvider>
				<Forms />
			</FormProvider>
		</>
	);
}
